import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Analytics from './pages/Analytics';
import Wrapped2025 from './pages/Wrapped2025';
import UserAcquisition from './pages/UserAcquisition';
import PromoCodes from './pages/PromoCodes';
import ActivationFunnel from './pages/ActivationFunnel';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import Fitnesses from './pages/Fitnesses';
import Foods from './pages/Foods';
import ScannedFoods from './pages/ScannedFoods';
import Weights from './pages/Weights';
import Activities from './pages/Activities';
import Measurements from './pages/Measurements';
import Teams from './pages/Teams';
import TeamDetail from './pages/TeamDetail';
import AssistantConversations from './pages/AssistantConversations';
import AssistantConversationDetail from './pages/AssistantConversationDetail';
import AssistantUsers from './pages/AssistantUsers';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route path="/wrapped-2025" element={<Wrapped2025 />} />
                    <Route path="/user-acquisition" element={<UserAcquisition />} />
                    <Route path="/promo-codes" element={<PromoCodes />} />
                    <Route path="/activation-funnel" element={<ActivationFunnel />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/users/:id" element={<UserDetail />} />
                    <Route path="/fitnesses" element={<Fitnesses />} />
                    <Route path="/foods" element={<Foods />} />
                    <Route path="/scanned-foods" element={<ScannedFoods />} />
                    <Route path="/weights" element={<Weights />} />
                    <Route path="/activities" element={<Activities />} />
                    <Route path="/measurements" element={<Measurements />} />
                    <Route path="/teams" element={<Teams />} />
                    <Route path="/teams/:id" element={<TeamDetail />} />
                    <Route path="/assistant" element={<AssistantConversations />} />
                    <Route path="/assistant/users" element={<AssistantUsers />} />
                    <Route path="/assistant/conversations/:id" element={<AssistantConversationDetail />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;

